<script setup lang="ts">
import { connectClearRefinements } from 'instantsearch.js/es/connectors';
import {
  ClearRefinementsConnectorParams,
  ClearRefinementsWidgetDescription,
} from 'instantsearch.js/es/connectors/clear-refinements/connectClearRefinements';
import { computed, PropType } from 'vue';

import { useWidget } from '@/composables/instant-search/useWidget';

const props = defineProps({
  // explicitly no default, since included and excluded are incompatible
  excludedAttributes: {
    type: Array as PropType<string[]>,
  },
  // explicitly no default, since included and excluded are incompatible
  includedAttributes: {
    type: Array as PropType<string[]>,
  },
});

const emit = defineEmits(['click']);

const widgetParams = computed<ClearRefinementsConnectorParams>(() => ({
  excludedAttributes: props.excludedAttributes,
  includedAttributes: props.includedAttributes,
}));

const { state } = useWidget<ClearRefinementsWidgetDescription, ClearRefinementsConnectorParams>(
  { connector: connectClearRefinements },
  widgetParams,
);

const refine = () => {
  state.value?.refine();
  emit('click');
};
</script>

<template>
  <div v-if="state">
    <button
      type="reset"
      class="clear-filters"
      :disabled="!state.canRefine"
      @click.prevent="refine"
      data-test="clear-filters"
    >
      Reset filters
    </button>
  </div>
</template>
